import "./IconEmail.scss";

export const IconEmail = () => {
  return <span className="icon-email"></span>;
};
